import React from "react";

export function PayoutHistoryToolbar({ search, onSearchChange, onFilterClick }) {
  return (
    <div className="mb-4 md:mb-6">
      <h2 className="my-0 text-[15px] font-semibold text-[#111827] md:text-[16px]">
        Payment History
      </h2>
    </div>
  );
}
